const tabStates = [
    'policies.detail.contacts.policy',
    'policies.detail.contacts.account',
    'policies.detail.contacts.related'
];


class PolicyContactSummaryCtrl {
    constructor($scope, $state) {
        this._state = $state;
        this._setSelectedVars($state.current.name);
        $scope.$on('$stateChangeSuccess', (event, toState) => {
            this._setSelectedVars(toState.name);
        });
    }

    selectTab(idx) {
        this._state.go(tabStates[idx]);
    }

    _setSelectedVars(stateName) {
        this.policySelected = tabStates.indexOf(stateName) === 0;
        this.accountSelected = tabStates.indexOf(stateName) === 1;
        this.relatedSelected = tabStates.indexOf(stateName) === 2;
    }
}

PolicyContactSummaryCtrl.$inject = ['$scope', '$state'];

export default PolicyContactSummaryCtrl;